import { render, staticRenderFns } from "./ComponentSlider.vue?vue&type=template&id=169ae636&scoped=true&"
import script from "./ComponentSlider.vue?vue&type=script&lang=js&"
export * from "./ComponentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSlider.vue?vue&type=style&index=0&id=169ae636&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ae636",
  null
  
)

export default component.exports